import ReportModel from "@/models/reports/report_model";

export default class IncomeStatementModel extends ReportModel {
    constructor() {
        super();
    }
}